export const INDEX = '/';
export const SIGN_IN = '/signin';
export const SignUp = '/sign-up';
export const DepositeConfirmation = '/deposite-confirmation';
export const DepositeConfirmationOLD = '/deposite-confirmation/';
export const Sales = '/Sales';
export const SalesOrderNotification = '/SalesOrderNotification';

export const HOME = '/home';
export const Admin = '/admin';
export const GManager = '/general-manager';
export const Distributor = '/distributor';
export const Employees = '/employees';
export const StoreOwners = '/store-owners';
export const StoreTagMapping = '/store-tag-mapping';
export const StoreChannelPartner = '/channel-partner';
export const Profile = '/profile';
export const TopSellers = '/top-sellers';
export const ReferStore = '/refer-store';
export const Training = '/training';
export const Help = '/help';
export const Download = '/download';
export const Royalty = '/royalty';

export const BonusPayout = '/bonus-payout';
export const Orders = '/orders';
export const Earning = '/earning';
export const StoreRegStatus = '/store-reg-status';
export const ReferralData = '/referral-data';
export const Notifications = '/notifications';
export const PaymentLinks = '/payment-links';
export const TransactionHistory = '/transaction-history';

export const MappingHistory = '/mapping-history';
export const Mapping = '/mapping';

export const ActivationSummary = '/activation-summary';
export const StoreActivation = '/store-activation';
export const StoreTag = '/store-tag';
export const ViewProfile = '/view-profile';

export const WalletSummary = '/wallet-summary';
export const PartnerWalletManagement = '/partner-wallet-management';
export const WalletCredits = '/wallet-credits';
export const DailyCreditSummary = '/wallet-credits-summary';

export const GiftCards = '/gift-cards';
export const QwikCilverNonAmazon = '/non-amazone-gift-cards';

export const GiftCardsHistory = '/my-gift-cards';
export const ManageCommission = '/payment-gateway-configuration';

export const ManageSiteStatus = '/site-status';
export const GCAccounts = '/gc-accounts';
export const GCCategory = '/gc-catalogs';
export const GCSlugs = '/gc-slugs';
export const GCTransactions = '/gift-card-transactions';
export const InstaUsers = '/insta-users';
export const InstaOrders = '/insta-orders';
export const InstaBanners = '/insta-banners';
export const InstaTransaction ='/insta-transaction';
export const GCReports = '/report-central';
export const GCList = '/all-gift-cards';
export const BrandwiseReport = '/brandwise-report';

export const TermsConditions = '/termsofuse';
export const PrivacyPolicy = '/privacy';
export const WebsiteCookiePolicy = '/cookie-policy';
export const RefundPolicy = '/faq';
export const ContactUs = '/contact-us';
export const AmazonPayTC = '/apaytnc';

export const FlipKartProducts = '/flipkart-orders';
export const FintechProducts = '/fintech-products';
export const DailyWalletReport = '/daily-wallet-report';
export const MyDailyWalletReport = '/my-daily-wallet-report';

export const DASHBOARD = '/dashboard';
export const Migrations = '/migrations';


export const CashbackOffers = '/cashback-offers';
